import { ColorName } from "@zapier/design-system";

export const DARK_COLOR = "#201515";
export const LIGHT_COLOR = "#f9f7f3";

export function getContrastingTextColor(
  backgroundColor: string,
  inHexFormat: boolean = false,
): ColorName | string {
  // Remove "#" if present
  const cleanHex = backgroundColor.replace(/^#/, "");

  // Parse RGB components
  const r = parseInt(cleanHex.slice(0, 2), 16);
  const g = parseInt(cleanHex.slice(2, 4), 16);
  const b = parseInt(cleanHex.slice(4, 6), 16);

  // Calculate luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Return the appropriate color token based on luminance
  return luminance > 0.6
    ? inHexFormat
      ? DARK_COLOR
      : "BrandEarth"
    : inHexFormat
      ? LIGHT_COLOR
      : "GrayWarm1";
}
